import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface CultureDTO {
	_id: string;
	name: string;
	isPublic: boolean;
	userId?: string;
}

export interface PaginatedCulturesResponse {
	docs: CultureDTO[];
	totalDocs: number;
	limit: number;
	totalPages: number;
	page: number;
}

export interface UseGetCulturesParams {
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export function useGetCultures({
	page = 1,
	limit = 1000,
	enabled = true,
}: UseGetCulturesParams = {}) {
	const query = useQuery<PaginatedCulturesResponse>({
		queryKey: ['cultures', page, limit],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<PaginatedCulturesResponse>('/cultures/findAll', {
				params: { page, limit },
			});
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? { totalDocs: query.data.totalDocs, totalPages: query.data.totalPages, page: query.data.page }
			: null,
	};
}
